import React from 'react';
import HeaderContainer from 'containers/header';
import DetailContainer from 'containers/detail';
import FooterContainer from 'containers/footer';

const DetailPage = () => {
  return (
    <div>
      <HeaderContainer />
      <DetailContainer />
      <FooterContainer />
    </div>
  );
};

export default DetailPage;
